(function () {

  'use strict';

  angular.module('DownloadClient', []);

  angular.module(angular.element('html').attr('ng-app'), [
    'ngAnimate',
    'ngCookies',
    'ngRoute',
    'angular.filter',
    'angularMoment',
    'focusOn',
    'ngBootbox',
    'toastr',
    'PrintixUtils',
    'PrintixError',
    'PrintixLanguageMenu',
    'PrintixMainMenu',
    'PrintixNavigationBar',
    'PrintixPageHeader',
    'ng.deviceDetector',
    'PrintixProviderTenant',
    'SoftwareProvider',
    'DownloadClient'
  ])

    .constant('USER_RIGHTS', {
      ACCESS_GRANT: 'ACCESS_GRANT',
      CHANGE_PRINTER_ACTIVE_STATE: 'RESOURCE_PRINTER_ACTIVE',
      OPEN_ADMINISTRATOR_WEB_APP: 'ADMIN_LOGIN',
      PRINT_ID_SIGN: 'PRINT_ID_SIGN',
      RESOURCE_PRINTJOB_CREATE: 'RESOURCE_PRINTJOB_CREATE',
      ADMIN_LOGIN: 'ADMIN_LOGIN'
    })

    .constant('USER_ROLES', {
      USER: 'USER',
      SYSTEM_MANAGER: 'SYSTEM_MANAGER'
    })

    .constant('SETUP_ASSISTANT', {
      SHOW_INTRODUCTION: 'SHOW_INTRODUCTION',
      DOWNLOAD_CLIENT: 'DOWNLOAD_CLIENT',
      AWAIT_WORKSTATION: 'AWAIT_WORKSTATION',
      AWAIT_INITIAL_DISCOVERY: 'AWAIT_INITIAL_DISCOVERY',
      OPEN_DASHBOARD: 'OPEN_DASHBOARD',
      SETUP_AUTH: 'SETUP_AUTH',
      ADD_USER: 'ADD_USER'
    })

    .constant('URLS', {
      DOWNLOAD_CLIENT: '/client'
    })

    .constant('TEMPLATE_PATHS', {
      DOWNLOAD_CLIENT_PATH: 'app/components/client/downloadClientView.html'
    })

    .config(function ($routeProvider, $httpProvider, URLS, TEMPLATE_PATHS, $translateProvider, toastrConfig) {
      $translateProvider.useSanitizeValueStrategy('escape');

      $httpProvider.defaults.headers.common = { Accept: 'application/hal+json, application/json' };
      $httpProvider.defaults.headers.post = {};
      $httpProvider.defaults.headers.put = {};
      $httpProvider.defaults.headers.patch = {};

      angular.extend(toastrConfig, {
        iconClasses: {
          error: 'toast--error',
          info: 'toast--info',
          success: 'toast--success',
          warning: 'toast--warning'
        },
        messageClass: 'toast__message',
        titleClass: 'toast__title',
        toastClass: 'toast'
      });

      const currentTenant = function (TenantListService) {
        return TenantListService.currentTenant || TenantListService.resolveCurrentTenant();
      };

      $routeProvider
        .when(URLS.DOWNLOAD_CLIENT, {
          templateUrl: TEMPLATE_PATHS.DOWNLOAD_CLIENT_PATH,
          controller: 'DownloadClientController',
          resolve: {
            currentTenant
          }
        })
        .otherwise({
          redirectTo: URLS.DOWNLOAD_CLIENT
        });

      $httpProvider.interceptors.push(
        'PrintixRequestHeaderManager',
        'templateCacheBusterInterceptor'
      );
    })

    .constant('API_VALUES', {
      APP_NAMES_URL: 'assets/jsonFiles/appName/appNameItems.json'
    })

    .service('EnvironmentService', function ($location, $log) {
      const host = $location.host();
      const environment = environments.find(function (environment) { return host.endsWith(environment.match); });
      if (environment) {
        this.authDomain = environment.authDomain;
        this.apiDomain = environment.apiDomain;
      } else {
        // Determine if this is a printix.dev environment host
        // Don't use regex in order to include broadest platform support.
        const pos = host.indexOf('.printix.dev');
        const subdomain = pos >= 5 ? host.substring(pos - 5) : '';
        if (subdomain.startsWith('dev') && subdomain.length === 17) {
          this.authDomain = 'auth.' + subdomain;
          this.apiDomain = 'api.' + subdomain;
        } else {
          $log.error('Failed to detect current environment!');
        }
      }
    })

    .run(function ($rootScope, $filter, API_VALUES, $http, ArrayPrototypes, PrintixErrorService, PageTitleManager, AutoCloseModelOnNavChange, TenantListService) {
      $rootScope.appNameItems = [];
      $rootScope.currentAppName = '';
      $rootScope.clientNameValue = '';

      $rootScope.readAppNameItems = function () {
        $http.get(API_VALUES.APP_NAMES_URL, { cache: true }).then(function (response) {
          $rootScope.appNameItems = [];
          angular.forEach(response.data, function (appNameItem) {
            $rootScope.appNameItems.push(appNameItem);
          });
          if ($rootScope.appNameItems && $rootScope.appNameItems.length) {
            $rootScope.currentAppName = $filter('filter')($rootScope.appNameItems, { key: 'Download' })[0].value;
            $rootScope.clientNameValue = $filter('filter')($rootScope.appNameItems, { key: 'Client' })[0].value;
          } else {
            throw new Error('$rootScope.readAppNameItems: $rootScope.appNameItems is missing or it is empty');
          }
        });
      };

      $rootScope.readAppNameItems();
    });

})();
